import { render, staticRenderFns } from "./CustomerHubCourses.vue?vue&type=template&id=20e67854&scoped=true"
import script from "./CustomerHubCourses.vue?vue&type=script&lang=js"
export * from "./CustomerHubCourses.vue?vue&type=script&lang=js"
import style0 from "./CustomerHubCourses.vue?vue&type=style&index=0&id=20e67854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e67854",
  null
  
)

export default component.exports